import React from 'react'
import StaticSection from './sections/StaticSection'
import { sectionForType } from './sections/sectionForType'
import { LABELS } from '../constants/staticText'
import { UnterEbene } from '../../lib/a11y/Ueberschrift'

// Die Typ->Komponente-Zuordnung liegt in sections/sectionForType.jsx — eine
// Quelle für Kachelseite und Shortcode (#177). Unbekannte Typen und freetext
// rendern den eigenen Text (StaticSection).
const EventSection = ({ tile, event, data, headingRef = null }) => {
    if (!tile) return <p className="section-empty">{LABELS.error}</p>
    if ('comingSoon' === tile.state) return <p className="section-empty">{LABELS.comingSoon}</p>

    const Section = sectionForType(tile.type)

    return (
        <section className="event-section">
            {/* h1: der Abschnitt ist die Seite (Audit 2026-10-07, S3). */}
            <h1 className="event-section-title" tabIndex={-1} ref={headingRef}>{tile.title}</h1>
            {/* Die Ueberschriften der Abschnitte stehen unter dieser h1 (#236);
                im Shortcode stehen sie unter dessen h2 und bleiben h3. */}
            <UnterEbene ebene={1}>
                {Section ? <Section data={data} event={event} tile={tile} /> : <StaticSection tile={tile} event={event} />}
            </UnterEbene>
        </section>
    )
}

export default EventSection
